/* eslint-disable max-lines */
/* eslint-disable no-restricted-syntax */
import React, { ComponentPropsWithoutRef } from 'react';
import '@assets/css/icons.css';

export function CloseIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18 18 6M6 6l12 12"
      />
    </svg>
  );
}

export function BlueCircleIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      className="h-1.5 w-1.5 fill-blue-500"
      viewBox="0 0 6 6"
      aria-hidden="true"
      {...props}
    >
      <circle cx={3} cy={3} r={3} />
    </svg>
  );
}

export function BlueDotIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      className="h-1.5 w-1.5 fill-blue-500"
      viewBox="0 0 6 6"
      aria-hidden="true"
      {...props}
    >
      <circle cx={3} cy={3} r={3} />
    </svg>
  );
}

export function ExportIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 92 92"
      id="export"
      fill="currentColor"
      {...props}
    >
      <path d="M73 76.5v5c0 2.2-1.9 3.5-4.1 3.5H3.6C1.4 85 0 83.8 0 81.5V32.1c0-2.2 1.4-4.2 3.6-4.2h11.7c2.2 0 4 1.8 4 4s-1.8 4-4 4H8V77h57v-.5c0-2.2 1.8-4 4-4s4 1.8 4 4zm17.8-37.3L66 64.5c-1.2 1.2-2.9 1.5-4.4.9-1.6-.7-2.6-2.1-2.6-3.8V50.7c-8-.2-27.2.6-34.2 12.9-.7 1.3-2.1 2.1-3.5 2.1-.3 0-.7 0-1-.1-1.8-.5-3-2.1-3-3.9 0-.6 0-16.1 11.6-27.6C36.2 26.6 46 22.6 59 21.9V11c0-1.6 1-3.1 2.5-3.7 1.6-.6 3.3-.3 4.5.9l24.9 25.3c1.5 1.6 1.5 4.1-.1 5.7zm-8.6-2.9L67 20.9v4.9c0 2.2-1.7 4-4 4-12.4 0-21.9 3.3-28.4 9.9-3 3-5 6.3-6.3 9.5 9.4-5.6 21.3-6.6 28.6-6.6 3.8 0 6.3.3 6.6.3 2 .2 3.5 2 3.5 4v4.9l15.2-15.5z"></path>
    </svg>
  );
}

export function GreenCircleIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      className="h-1.5 w-1.5 fill-green-500"
      viewBox="0 0 6 6"
      aria-hidden="true"
      {...props}
    >
      <circle cx={3} cy={3} r={3} />
    </svg>
  );
}

export function MarkerIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <rect width="24" height="24" stroke="none" fill="#000000" opacity="0" />

      <g transform="matrix(1 0 0 1 12 12)">
        <g>
          <g transform="matrix(1 0 0 1 0 0)">
            <path
              style={{
                stroke: 'none',
                strokeWidth: 2,
                strokeDasharray: 'none',
                strokeLinecap: 'round',
                strokeDashoffset: 0,
                strokeLinejoin: 'round',
                strokeMiterlimit: 4,
                fill: 'none',
                fillRule: 'nonzero',
                opacity: 1
              }}
              transform=" translate(-12, -12)"
              d="M 0 0 L 24 0 L 24 24 L 0 24 z"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1 0 0 1 -1.34 -0.66)">
            <path
              style={{
                stroke: 'rgb(33,33,33)',
                strokeWidth: 1,
                strokeDasharray: 'none',
                strokeLinecap: 'round',
                strokeDashoffset: 0,
                strokeLinejoin: 'round',
                strokeMiterlimit: 4,
                fill: 'none',
                fillRule: 'nonzero',
                opacity: 1
              }}
              transform=" translate(-10.66, -11.34)"
              d="M 3 19 L 7 19 L 17.5 8.5 C 18.604569499661586 7.3954305003384135 18.604569499661586 5.604569499661587 17.5 4.5 C 16.395430500338414 3.3954305003384135 14.604569499661586 3.3954305003384135 13.5 4.5 L 3 15 L 3 19"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1 0 0 1 2.5 -4.5)">
            <path
              style={{
                stroke: 'rgb(33,33,33)',
                strokeWidth: 1,
                strokeDasharray: 'none',
                strokeLinecap: 'round',
                strokeDashoffset: 0,
                strokeLinejoin: 'round',
                strokeMiterlimit: 4,
                fill: 'none',
                fillRule: 'nonzero',
                opacity: 1
              }}
              transform=" translate(-14.5, -7.5)"
              d="M 12.5 5.5 L 16.5 9.5"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1 0 0 1 -5.5 3.5)">
            <path
              style={{
                stroke: 'rgb(33,33,33)',
                strokeWidth: 1,
                strokeDasharray: 'none',
                strokeLinecap: 'round',
                strokeDashoffset: 0,
                strokeLinejoin: 'round',
                strokeMiterlimit: 4,
                fill: 'none',
                fillRule: 'nonzero',
                opacity: 1
              }}
              transform=" translate(-6.5, -15.5)"
              d="M 4.5 13.5 L 8.5 17.5"
              strokeLinecap="round"
            />
          </g>
          <g transform="matrix(1 0 0 1 5 5)">
            <path
              style={{
                stroke: 'rgb(33,33,33)',
                strokeWidth: 1,
                strokeDasharray: 'none',
                strokeLinecap: 'round',
                strokeDashoffset: 0,
                strokeLinejoin: 'round',
                strokeMiterlimit: 4,
                fill: 'none',
                fillRule: 'nonzero',
                opacity: 1
              }}
              transform=" translate(-17, -17)"
              d="M 21 15 L 21 19 L 13 19 L 17 15 z"
              strokeLinecap="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function MicrosoftIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      height="32"
      width="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="h-5 w-5 fill-[#0077B5]"
      {...props}
    >
      <g>
        <g id="Microsoft_1_">
          <g id="Microsoft">
            <g id="Blue_x5F_Square">
              <rect height="15" style={{ fill: '#51AED9' }} width="15" y="17" />
            </g>
            <g id="Yellow_x5F_Square">
              <rect
                height="15"
                style={{ fill: '#FEC327' }}
                width="15"
                x="17"
                y="17"
              />
            </g>
            <g id="Green_x5F_Square">
              <rect height="15" style={{ fill: '#34B67A' }} width="15" x="17" />
            </g>
            <g id="Orange_x5F_Square">
              <rect height="15" style={{ fill: '#F15723' }} width="15" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function NewProjectIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      className="mx-auto h-12 w-12 text-gray-400 dark:text-zinc-500"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
      />
    </svg>
  );
}

export function PlayIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 36 36"
      aria-hidden="true"
      {...props}
      stroke="currentColor"
    >
      <path d="M33.75 16.701C34.75 17.2783 34.75 18.7217 33.75 19.299L11.25 32.2894C10.25 32.8668 9 32.1451 9 30.9904L9 5.00962C9 3.85491 10.25 3.13323 11.25 3.71058L33.75 16.701Z" />
    </svg>
  );
}

export function QuestionMarkIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
      />
    </svg>
  );
}

export function ReplaceIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.2em"
      height="1.2em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm12 12a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm6-5V8a2 2 0 0 0-2-2h-6l3 3m0-6l-3 3M3 13v3a2 2 0 0 0 2 2h6l-3-3m0 6l3-3"
      />
    </svg>
  );
}

export function ResetIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      viewBox="0 0 512 512"
      width={18}
      height={18}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      stroke="#1aa1f4"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g id="Layer_1"></g>
        <g id="Layer_2">
          <g>
            <path
              className="st0"
              d="M274.91,47.78c-97.6,0-179.71,67.5-202.15,158.26L58.79,181.4c-4.36-7.69-14.12-10.39-21.81-6.03 c-7.69,4.36-10.39,14.12-6.03,21.81l37.66,66.44c0,0,0,0.01,0.01,0.01l0.15,0.26c0.19,0.34,0.39,0.66,0.6,0.98 c0.01,0.01,0.02,0.03,0.03,0.04c0.04,0.07,0.09,0.13,0.14,0.19c0.23,0.33,0.46,0.64,0.71,0.95c0.04,0.05,0.07,0.1,0.11,0.15 c0,0,0,0.01,0.01,0.01c0.02,0.02,0.04,0.04,0.06,0.07c0.36,0.44,0.75,0.85,1.15,1.24c0.04,0.04,0.07,0.07,0.11,0.1 c0.25,0.23,0.5,0.46,0.76,0.67c0.05,0.04,0.1,0.08,0.15,0.12c0.35,0.28,0.71,0.55,1.08,0.81c0.03,0.02,0.06,0.04,0.09,0.06 c0.17,0.11,0.35,0.22,0.52,0.33c0.09,0.06,0.18,0.11,0.28,0.17c0.12,0.07,0.25,0.14,0.38,0.21c0.11,0.06,0.22,0.12,0.33,0.17 c0.2,0.1,0.39,0.2,0.59,0.3c0.11,0.05,0.22,0.1,0.33,0.15c0,0,0.01,0,0.01,0.01c0.12,0.05,0.24,0.11,0.36,0.16 c0.33,0.14,0.66,0.26,1,0.37c0.04,0.02,0.09,0.03,0.13,0.04c0.02,0.01,0.03,0.01,0.05,0.02c0.15,0.05,0.31,0.09,0.47,0.14 c0.29,0.09,0.59,0.16,0.89,0.23c0.08,0.02,0.15,0.04,0.23,0.06c0.07,0.02,0.14,0.03,0.22,0.05c0.44,0.09,0.89,0.15,1.33,0.2 c0.04,0,0.07,0.01,0.11,0.02c0.08,0.01,0.15,0.01,0.23,0.02c0.49,0.05,0.98,0.08,1.48,0.08c0.42,0,0.84-0.02,1.26-0.06 c0.07-0.01,0.14-0.01,0.21-0.02c0.01,0,0.03,0,0.04,0c0.06-0.01,0.12-0.01,0.19-0.02c0.28-0.03,0.55-0.07,0.83-0.11 c0.08-0.01,0.16-0.02,0.24-0.04c0.13-0.02,0.25-0.04,0.38-0.07c0.06-0.01,0.12-0.03,0.19-0.04c0.4-0.09,0.81-0.19,1.21-0.31 c0.1-0.03,0.2-0.06,0.3-0.09c0.11-0.03,0.21-0.07,0.32-0.11c0.14-0.05,0.28-0.1,0.42-0.15c0.17-0.06,0.33-0.12,0.5-0.19 c0.1-0.04,0.2-0.09,0.3-0.13c0.13-0.06,0.26-0.12,0.39-0.18c0.19-0.09,0.37-0.19,0.56-0.28c0.13-0.07,0.25-0.13,0.38-0.2 c0.28-0.15,0.55-0.33,0.82-0.5c0.15-0.09,0.3-0.18,0.45-0.28c0.06-0.04,0.11-0.08,0.17-0.12c0.17-0.12,0.34-0.25,0.5-0.38 c0.06-0.04,0.12-0.09,0.18-0.13c0.11-0.09,0.23-0.17,0.34-0.26c0,0,0.01-0.01,0.01-0.01l59.04-48.93 c6.8-5.64,7.75-15.72,2.11-22.53c-5.64-6.8-15.73-7.75-22.53-2.11l-28.84,23.9c17.18-79.28,87.87-138.87,172.22-138.87 c97.17,0,176.22,79.05,176.22,176.22s-79.05,176.22-176.22,176.22c-8.84,0-16,7.16-16,16s7.16,16,16,16 c114.81,0,208.22-93.41,208.22-208.22S389.72,47.78,274.91,47.78z"
            ></path>
            <path
              className="st0"
              d="M274.91,147.61c-8.84,0-16,7.16-16,16V256c0,8.84,7.16,16,16,16h75.87c8.84,0,16-7.16,16-16s-7.16-16-16-16 h-59.87v-76.39C290.91,154.77,283.74,147.61,274.91,147.61z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function SaveIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.1em"
      height="1.1em"
      viewBox="0 0 14 14"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      >
        <path d="M2.75 2.75v10.5h10.5v-7.5l-3-3z" />
        <path d="M5.75 13.25v-3.5h4.5v3.5" />
      </g>
    </svg>
  );
}

const ItalicIcon = ({
  className,
  width = 32,
  height = 36,
  style
}: {
  className?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}) => {
  return (
    <div className="italic-icon mt-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`feather feather-italic ${className} h-full w-full`}
        style={style}
      >
        <line x1="19" y1="4" x2="10" y2="4"></line>
        <line x1="14" y1="20" x2="5" y2="20"></line>
        <line x1="15" y1="4" x2="9" y2="20"></line>
      </svg>
    </div>
  );
};

export default ItalicIcon;

export function EyeOn(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      />
    </svg>
  );
}

export function EyeOff(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
      />
    </svg>
  );
}

export function DoubleArrowLeft(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
      />
    </svg>
  );
}

export function DoubleArrowRight(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
      />
    </svg>
  );
}

export function ArrowLeft(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 19.5 8.25 12l7.5-7.5"
      />
    </svg>
  );
}

export function ArrowRight(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m8.25 4.5 7.5 7.5-7.5 7.5"
      />
    </svg>
  );
}
